webpackJsonp([10],{

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Trackable = __webpack_require__(594);

var _Trackable2 = _interopRequireDefault(_Trackable);

var _MetaTags = __webpack_require__(595);

var _MetaTags2 = _interopRequireDefault(_MetaTags);

var _HeroBase = __webpack_require__(593);

var _HeroBase2 = _interopRequireDefault(_HeroBase);

var _PrivacyContent = __webpack_require__(684);

var _PrivacyContent2 = _interopRequireDefault(_PrivacyContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var title = 'Intento Privacy Policy';
var description = 'Access many AI vendors via a single integration with up to 23x better performance/price efficiency by using the right model for your specific case.';
var metatags = {
    title: title,
    description: description,
    og: {
        title: title,
        description: description,
        url: 'https://inten.to/privacy'
    },
    twitter: {
        title: title,
        description: description
    }
};

var Support = function Support() {
    return _react2.default.createElement(
        _Trackable2.default,
        { page: 'privacy' },
        _react2.default.createElement(_MetaTags2.default, { tags: metatags }),
        _react2.default.createElement(
            _HeroBase2.default,
            { center: true },
            _react2.default.createElement(
                'h1',
                { className: 'hero__title h1' },
                'Privacy Policy'
            )
        ),
        _react2.default.createElement(_PrivacyContent2.default, null)
    );
};

exports.default = Support;

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(592);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroBase = function HeroBase(_ref) {
    var children = _ref.children,
        cols = _ref.cols,
        center = _ref.center,
        className = _ref.className;
    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)('hero hero--main hero--gradient-blue ' + (center ? 'hero--center' : ''), className)
        },
        _react2.default.createElement(
            'div',
            { className: 'hero__container container' },
            _react2.default.createElement(
                'div',
                { className: cols ? 'hero__cols' : 'hero__content' },
                children
            )
        )
    );
};

exports.default = HeroBase;

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Trackable = function (_React$Component) {
    _inherits(Trackable, _React$Component);

    function Trackable() {
        _classCallCheck(this, Trackable);

        return _possibleConstructorReturn(this, (Trackable.__proto__ || Object.getPrototypeOf(Trackable)).apply(this, arguments));
    }

    _createClass(Trackable, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var page = this.props.page;

            if (!window.userLanded) {
                var params = {
                    page: page,
                    ab_group: (0, _utils.getCookieValue)('ab_group')
                    // locale: i18n.lng()
                };

                (0, _utils.track)('User landed', params, function () {
                    window.userLanded = true;
                    window.ab_group = (0, _utils.getCookieValue)('ab_group');
                });
            }

            // track page open as well, regardless of the initial landing
            (0, _utils.track)('Page opened', {
                page: page
                // locale: i18n.lng()
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className;

            return _react2.default.createElement(
                'main',
                { className: 'content ' + className },
                children
            );
        }
    }]);

    return Trackable;
}(_react2.default.Component);

exports.default = Trackable;

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// changes here requires dev server to restart
// because this component is used in the site config `static.config.js`

var LOGO = 'https://inten.to/img/brain.png';
var DESCRIPTION = 'Discover, evaluate and use best-of-breed AI. A simple and elegant API to third-party AI models from many vendors.';
var TITLE = 'Intento';

var DEFAULT_TAGS = {
    title: TITLE,
    description: DESCRIPTION,
    logo: LOGO,
    author: 'Intento Inc.',
    twitter: {
        title: TITLE,
        description: DESCRIPTION,
        image: LOGO
    },
    og: {
        title: TITLE,
        site_name: TITLE,
        description: DESCRIPTION,
        image: LOGO,
        imageHeight: 300,
        imageWidth: 300,
        url: 'https://inten.to/'
    }
};

var MetaTags = function MetaTags(props) {
    var _props$tags = props.tags,
        tags = _props$tags === undefined ? DEFAULT_TAGS : _props$tags;

    var meta = _extends({}, DEFAULT_TAGS, tags, {
        description: (tags.description || '') + ' \u2014 ' + DESCRIPTION,
        twitter: _extends({}, DEFAULT_TAGS.twitter, tags.twitter, {
            description: ((tags.twitter || {}).description || '') + ' \u2014 ' + DESCRIPTION
        }),
        og: _extends({}, DEFAULT_TAGS.og, tags.og, {
            description: ((tags.og || {}).description || '') + ' \u2014 ' + DESCRIPTION
        })
    });

    return _react2.default.createElement(
        _reactStatic.Head,
        null,
        _react2.default.createElement(
            'title',
            null,
            meta.title
        ),
        _react2.default.createElement('meta', { name: 'description', content: meta.description }),
        _react2.default.createElement('meta', { name: 'author', content: meta.author }),
        _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
        _react2.default.createElement('meta', { property: 'og:title', content: meta.og.title }),
        _react2.default.createElement('meta', { property: 'og:site_name', content: meta.og.site_name }),
        _react2.default.createElement('meta', { property: 'og:url', content: meta.og.url }),
        _react2.default.createElement('meta', { property: 'og:description', content: meta.og.description }),
        _react2.default.createElement('meta', { property: 'og:image', content: meta.og.image }),
        _react2.default.createElement('meta', { property: 'og:image:height', content: meta.og.imageHeight }),
        _react2.default.createElement('meta', { property: 'og:image:width', content: meta.og.imageWidth }),
        _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary' }),
        _react2.default.createElement('meta', { name: 'twitter:title', content: meta.twitter.title }),
        _react2.default.createElement('meta', {
            name: 'twitter:description',
            content: meta.twitter.description
        }),
        _react2.default.createElement('meta', { name: 'twitter:image', content: meta.twitter.image })
    );
};

exports.default = MetaTags;

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// prettier-disable
var PrivacyContent = function PrivacyContent() {
    return _react2.default.createElement(
        "div",
        { className: "terms_and_privacy_content" },
        _react2.default.createElement(
            "div",
            { className: "legal-section" },
            _react2.default.createElement(
                "div",
                { className: "law-speak" },
                _react2.default.createElement(
                    "h2",
                    null,
                    "Privacy Policy"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Intento, Inc (\u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4 c21" },
                        "Intento"
                    ),
                    "\u201D) complies with the EU\u2011U.S. Data Privacy Framework (EU\u2011U.S. DPF) and the UK Extension to the EU\u2011U.S. DPF, set forth by the U.S. Department of Commerce.  Intento, Inc has certified to the U.S. Department of Commerce that it adheres to the EU\u2011U.S. Data Privacy Framework Principles (\u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4 c21" },
                        "EU\u2011U.S. DPF Principles"
                    ),
                    ") with regard to the processing of personal data received from the European Union and the United Kingdom in reliance on the EU\u2011U.S. DPF and the UK Extension to the EU\u2011U.S. DPF. If there is any conflict between the terms in this privacy policy and the EU\u2011U.S. DPF Principles, the Principles shall govern.  To learn more about the Data Privacy Framework (DPF) program, and to view our certification, please visit ",
                    _react2.default.createElement(
                        "a",
                        { href: "https://www.dataprivacyframework.gov/" },
                        "https://www.dataprivacyframework.gov/"
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.yo1k0g3knd5h" },
                    "Scope"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Welcome to the web site (the \"Site\") of Intento, Inc. ( \"Intento\", \"we\", \"us\" and/or \"our\"). This Site is operated by Intento and has been created to provide information about our company and its content and data linking platform and related services (together with the Site, the \"Service(s)\") to our Service visitors (\"you\", \"your\")."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Intento\xA0complies with the Principles with respect to the Personal Data the company receives from its Customers or their Users in the European Union and the United Kingdom in connection with the use of (i) Intento website that has been created to provide information about our company and its content and data linking platform and related services (\u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Site"
                    ),
                    "\u201D); \xA0and (ii) Intento\u2019s hosted software applications (the \u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Subscription"
                    ),
                    "\xA0",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Services"
                    ),
                    "\u201D) and related support services (\u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Support Services"
                    ),
                    "\u201D), as well as expert services (including professional services, training and certification) (the \u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Expert Services"
                    ),
                    "\u201D) that we provide to Customers. \xA0In this Privacy Policy, the Subscription Service, Support Services and the Expert Services are collectively referred to as the \u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Service"
                    ),
                    ".\u201D"
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.tu1ip1djk6qb" },
                    "Definitions"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "For the purposes of this Privacy Policy:"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "\u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Controller"
                    ),
                    "\u201D means a person or organization which, alone or jointly with others, determines the purposes and means of the processing of Personal Data."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "\u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Customer"
                    ),
                    "\u201D means any entity that purchases the Service."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "\u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Customer Data"
                    ),
                    "\u201D means the electronic data uploaded into the Subscription Service by or for a Customer or its Users."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "\u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Device"
                    ),
                    "\u201D means a mobile device."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "\u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Personal Data"
                    ),
                    "\u201D means any information, including Sensitive Data, that is (i) about an identified or identifiable individual and (ii) received by Intento in the U.S. from the European Union or the United Kingdom in connection with the Service."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "\u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Processor"
                    ),
                    "\u201D means any natural or legal person, public authority, agency or other body that processes Personal Data on behalf of a Controller."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "\u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "Sensitive Data"
                    ),
                    "\u201D means Personal Data specifying medical or health conditions, racial or ethnic origin, political opinions, religious or philosophical beliefs, trade union membership, sex life, the commission or alleged commission of any offense, any proceedings for any offense committed or alleged to have been committed by the individual or the disposal of such proceedings, or the sentence of any court in such proceedings."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "\u201CUser\u201D"
                    ),
                    "\xA0means an individual authorized by Customer to access and use the Subscription Service."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.wf4en6kxdfka" },
                    "Types of Personal Data Collected"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Intento\xA0hosts and processes Customer Data, including any Personal Data contained therein, at the direction of and pursuant to the instructions of Intento\u2019s Customers. \xA0Intento also collects several types of information from our Customers, including:"
                ),
                _react2.default.createElement(
                    "ul",
                    { className: "c26 lst-kix_4qpejaw1iuon-0" },
                    _react2.default.createElement(
                        "li",
                        { className: "c9" },
                        "Information and correspondence our Customers and Users submit to us in connection with Expert Services or other requests related to our Service."
                    ),
                    _react2.default.createElement(
                        "li",
                        { className: "c9" },
                        "Information we receive from our business partners in connection with our Customers\u2019 and Users\u2019 use of the Service or in connection with services provided by our business partners on their behalf, including configuration of the Subscription Service."
                    ),
                    _react2.default.createElement(
                        "li",
                        { className: "c9" },
                        "Information related to Users\u2019 use of the Site, including geographic location data and information regarding Users\u2019 Devices and OS identification, login credentials, language and time zone."
                    )
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "In addition, Intento collects general information about its Customers, including a Customer\u2019s company name and address, credit card information, and the Customer representative\u2019s contact information (\u201C",
                    _react2.default.createElement(
                        "span",
                        { className: "c4" },
                        "General Information"
                    ),
                    "\u201D) for billing and contracting purposes. We will keep any information that you provide to us until such time as you delete your account with the Intento Services."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.7wugjux7lyfm" },
                    "Purposes of Collection and Use"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Intento\xA0may use Personal Data submitted by our Customers and Users as necessary to provide the Service and Mobile Applications, including updating, enhancing, securing and maintaining the Subscription Service and Mobile Applications and to carry out Intento\u2019s contractual obligations to its Customers. \xA0Intento also obtains General Information in connection with providing the Service and maintaining Intento\u2019s relationships with its Customers."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.g7mdac2gwh1b" },
                    "Third Party Disclosures"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "We may disclose Personal Data that our Customers and Users provide to our Service and Mobile Applications:"
                ),
                _react2.default.createElement(
                    "ul",
                    { className: "c26 lst-kix_bpgvrx8lo8o2-0" },
                    _react2.default.createElement(
                        "li",
                        { className: "c9" },
                        "To our subsidiaries and affiliates;"
                    ),
                    _react2.default.createElement(
                        "li",
                        { className: "c9" },
                        "To contractors, business partners and service providers we use to support our Service;"
                    ),
                    _react2.default.createElement(
                        "li",
                        { className: "c9" },
                        "In the event Intento sells or transfers all or a portion of its business or assets (including in the event of a merger, acquisition, joint venture, reorganization, dissolution or liquidation), in which case Personal Data held by us about our Customers will be among the assets transferred to the buyer or acquirer;"
                    ),
                    _react2.default.createElement(
                        "li",
                        { className: "c9" },
                        "If required to do so by law or legal process;"
                    ),
                    _react2.default.createElement(
                        "li",
                        { className: "c9" },
                        "In response to lawful requests from public authorities, including to meet national security, public interest or law enforcement requirements."
                    )
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.9feae1btm1rb" },
                    "Third-Party Service Integration"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Our Service allows you to integrate various online third-party services (\"Third-Party Services\"). In order to take advantage of this feature, you may need to authenticate, register for or log into Third-Party Services through the Service or on the websites of their respective providers. When you enable linking between or log in to Third-Party Services through the Service, we will collect relevant information necessary to enable the Service to access that Third-Party Service and your data and content contained within that Third-Party Service (\"Login Credentials\"). We store your Login Credentials long enough to enable linking to the Third-Party Service."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "When you enable the Service to link content and data between Third-Party Services, the Third-Party Services will provide us with access to certain information that you may have provided to the Third-Party Services, and we will use, store and disclose such information in accordance with this Privacy Policy and the rules you set to govern the linking. However, please remember that the manner in which Third-Party Services use, store and disclose your information is governed by the policies of such Third-Party Services, and Intento shall have no liability or responsibility for the privacy practices or other actions of any Third-Party Services that may be enabled within the Service."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "We may retain certain personally non-identifiable information related to the data or content linked between Third-Party Services (for example, date sent, link configuration, names of the Third-Party Services), for the purpose of improving our Services and as described below in the \"Non-Identifiable Data\" section."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.nsgh5w67ei0z" },
                    "Third-Party Payment Processor"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "We use a third party payment processor to process payments made to us. In connection with the processing of such payments, we do not retain any personally identifiable information or any financial information such as credit card numbers. Rather, all such information is provided directly to our third party processor, Stripe, whose use of your personal information is governed by their privacy policy, which may be viewed at ",
                    _react2.default.createElement(
                        "a",
                        { href: "https://stripe.com/us/privacy" },
                        "https://stripe.com/us/privacy"
                    ),
                    "."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.byv7kkhr8b16" },
                    "Children"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Intento does not knowingly collect Personal Data from children under the age of 13. If you are under the age of 13, please do not submit any Personal Data through the Services. We encourage parents and legal guardians to monitor their children's Internet usage and to help enforce our Privacy Policy by instructing their children never to provide Personal Data on the Services without their permission. If you have reason to believe that a child under the age of 13 has provided Personal Data to Intento through the Services, please contact us, and we will endeavor to delete that information from our databases."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.urrbts88k34" },
                    "Links to Other Web Sites"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "This Privacy Policy applies only to the Services. The Services may contain links to other web sites not operated or controlled by Intento (the \"Third-Party Sites\"). The policies and procedures we described here do not apply to the Third-Party Sites. The links from the Services do not imply that Intento endorses or has reviewed the Third-Party Sites. We suggest contacting those sites directly for information on their privacy policies."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.qivac4rl85dm" },
                    "Security"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Intento takes reasonable steps to protect the Personal Data provided via the Services from loss, misuse, and unauthorized access, disclosure, alteration, or destruction. However, no Internet or email transmission is ever fully secure or error free. In particular, email sent to or from the Services may not be secure. Therefore, you should take special care in deciding what information you send to us via email. Please keep this in mind when disclosing any Personal Data to Intento via the Internet."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.dfkgdio2spls" },
                    "Changes to Intento's Privacy Policy"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "The Services and our business may change from time to time. As a result, at times it may be necessary for Intento to make changes to this Privacy Policy. Intento reserves the right to update or modify this Privacy Policy at any time and from time to time. If we do this, we will post the changes to this Privacy Policy on this page and will indicate at the top of this page the date these terms were last revised. We will also notify you, either through the Service user interface, in an email notification or through other reasonable means. Please review this policy periodically, and especially before you provide any Personal Data. Any such changes will become effective no earlier than fourteen (14) days after they are posted, except that changes addressing new functions of the Service or changes made for legal reasons will be effective immediately. This Privacy Policy was last updated on the date indicated above. Your continued use of the Service after the date any such changes become effective constitutes your acceptance of the new Privacy Policy."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.kqw59zjw4c9g" },
                    "Other Terms"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Your access to and use of the Services is subject to the Terms of Service at\xA0",
                    _react2.default.createElement(
                        "a",
                        { href: "https://inten.to/terms" },
                        "https://intento.com/terms"
                    ),
                    "."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.l9t3kxcdw8rv" },
                    "Access"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Individuals in the European Union and the United Kingdom generally have the right to access their Personal Data. \xA0As an agent processing Personal Data on behalf of its Customers, Intento does not own or control the Personal Data that it processes on behalf of its Customers or their Users and does not have a direct relationship with the Users whose Personal Data may be processed in connection with providing the Service. \xA0Since each Customer is in control of what information, including any Personal Data, it collects from its Users, how that information is used and disclosed, and how that information can be changed, Users of the Subscription Service should contact the applicable Customer administrator with any inquiries about how to access or correct Personal Data contained in Customer Data. \xA0To the extent a User makes an access or correction request to Intento, we will refer the request to the appropriate Intento Customer and will support such Customer as needed in responding to any request."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "To access or correct any General Information Customer has provided, the Customer should contact their Intento account representative directly or by using the contact information indicated below. \xA0"
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.p3r8cyedd7ao" },
                    "Choice"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "In accordance with the Principles, Intento will offer Customers and Users choice to the extent it (i) discloses their Personal Data to third party Controllers, or (ii) uses their Personal Data for a purpose that is materially different from the purposes for which the Personal Data was originally collected or subsequently authorized by the Customer or User. \xA0To the extent required by the Principles, Intento also will obtain opt\u2011in consent if it engages in certain uses or disclosures of Sensitive Data. \xA0Unless Intento offers Customers and Users an appropriate choice, Intento uses Personal Data only for purposes that are materially the same as those indicated in this Policy."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Intento may disclose Personal Data of Customers and Users without offering an opportunity to opt out, and may be required to disclose the Personal Data, (i) to third\u2011party Processors that Intento has retained to perform services on its behalf and pursuant to its instructions, (ii) if it is required to do so by law or legal process, or (iii) in response to lawful requests from public authorities, including to meet national security, public interest or law enforcement requirements. \xA0Intento also reserves the right to transfer Personal Data in the event of an audit or if the company sells or transfers all or a portion of its business or assets (including in the event of a merger, acquisition, joint venture, reorganization, dissolution or liquidation)."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.klouu94jrc59" },
                    "Liability for Onward Transfers"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Intento\xA0complies with the Data Privacy\u2019s Principle regarding accountability for onward transfers. \xA0Intento remains liable under the Principles if its onward transfer recipients process Personal Data in a manner inconsistent with the Principles, unless Intento proves that it was not responsible for the event giving rise to the damage."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.cwfk2apjxmyn" },
                    "Complaints and Dispute Resolution"
                ),
                _react2.default.createElement(
                    "p",
                    { className: "c14" },
                    "In compliance with the EU\u2011U.S. DPF and the UK Extension to the EU\u2011U.S. DPF, Intento commits to resolve DPF Principles-related complaints about our collection and use of your personal information.  EU and UK individuals with inquiries or complaints regarding our handling of personal data received in reliance on the EU\u2011U.S. DPF and the UK Extension to the EU\u2011U.S. DPF, should first contact Intento at: ",
                    _react2.default.createElement(
                        "a",
                        { href: "mailto:legal@inten.to" },
                        "legal@inten.to"
                    ),
                    "\xA0or by regular mail as indicated below."
                ),
                _react2.default.createElement(
                    "p",
                    { className: "c14" },
                    "In compliance with the EU\u2011U.S. DPF and the UK Extension to the EU\u2011U.S. DPF, Intento commits to cooperate and comply respectively with the advice of the panel established by the EU data protection authorities (DPAs) and the UK Information Commissioner\u2019s Office (ICO) with regard to unresolved complaints concerning our handling of personal data received in reliance on the EU\u2011U.S. DPF and the UK Extension to the EU\u2011U.S. DPF. In certain circumstances, you may also invoke the EU\u2011U.S. DPF arbitration process. Under certain conditions, individuals may be entitled to invoke binding arbitration for unresolved complaints concerning DPF compliance. Intento is subject to the investigatory and enforcement powers of the U.S. Federal Trade Commission."
                ),
                _react2.default.createElement(
                    "h3",
                    { id: "h.nzapf29b923v" },
                    "How to Contact Intento"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "To keep your Personal Data accurate, current, and complete, please contact us as specified below. We will take reasonable steps to update or correct Personal Data in our possession that you have previously submitted via the Services. Please also feel free to contact us if you have any questions about Intento's Privacy Policy or the information practices of the Services."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "All disputes arising out of or relating to these Terms of Service will be submitted to the exclusive jurisdiction of a court of competent jurisdiction located in Wilmington, Delaware, and each party irrevocably consents to such personal jurisdiction and waives all objections to this venue."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "To ask questions or comment about this Privacy Policy and our privacy practices or if you need to update, change or remove your information, contact us at: \xA0",
                    _react2.default.createElement(
                        "a",
                        { href: "mailto:legal@inten.to" },
                        "legal@inten.to"
                    ),
                    " or by regular mail addressed to:"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Intento, Inc."
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "Attn: Privacy"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "2261 Market Street #4273"
                ),
                _react2.default.createElement(
                    "p",
                    null,
                    "San Francisco, CA 94114, United States"
                )
            )
        )
    );
};

exports.default = PrivacyContent;

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Privacy.f18351e9.js